module.exports = __webpack_public_path__ + "img/312D20_80675C_8B8C8B_85848C-256px.c5935cd8.png";